<template>
  <section class="hero is-fullheight cart-page">
    <PmNavbar />

    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-4 white-bg p-5 has-text-centered-mobile">
            <h1 class="custom-black is-ubuntu mb-4">Kirjautuminen</h1>
            <label>Sähköpostiosoite *</label>
            <input
              v-model="form.email"
              type="email"
              class="input pm-input mb-3"
              placeholder="Sähköpostiosoite *"
            />
            <label>Salasana *</label>
            <input
              v-model="form.password"
              type="password"
              class="input pm-input mb-4"
              placeholder="Salasana *"
            />
            <label>Toista salasana *</label>
            <input
              v-model="form.confirmPassword"
              type="password"
              class="input pm-input mb-4"
              placeholder="Toista salasana *"
            />

            <h3 class="custom-black is-ubuntu mb-5">Tilaajan tiedot</h3>

            <label>Yritys/Yhdistys *</label>
            <input v-model="form.recv_company" class="input pm-input mb-3" placeholder="Yritys/Yhdistys *" />
            <label>Yhteyshenkilö *</label>
            <input v-model="form.recv_name" class="input pm-input mb-3" placeholder="Yhteyshenkilö *" />
            <label>Puhelinnumero *</label>
            <input v-model="form.recv_phone" class="input pm-input mb-3" placeholder="Puhelinnumero *" />
            <label>Katuosoite *</label>
            <input v-model="form.recv_street" class="input pm-input mb-3" placeholder="Katuosoite *" />
            <label>Postinumero *</label>
            <input v-model="form.recv_zip" class="input pm-input mb-3" placeholder="Postinumero *" />
            <label>Postitoimipaikka *</label>
            <input v-model="form.recv_town" class="input pm-input mb-3" placeholder="Postitoimipaikka *" />

            <hr>

            <label class="checkbox">
              <input type="checkbox" v-model="differentBilling" />
              Toimitusosoite on eri kuin yhteystieto
            </label>

            <div v-if="differentBilling">
              <label>Yritys/Yhdistys *</label>
              <input v-model="form.bill_company" class="input pm-input mb-3" placeholder="Yritys/Yhdistys *" />
              <label>Yhteyshenkilö *</label>
              <input v-model="form.bill_name" class="input pm-input mb-3" placeholder="Yhteyshenkilö *" />
              <label>Puhelinnumero *</label>
              <input v-model="form.bill_phone" class="input pm-input mb-3" placeholder="Puhelinnumero *" />
              <label>Katuosoite *</label>
              <input v-model="form.bill_street" class="input pm-input mb-3" placeholder="Katuosoite *" />
              <label>Postinumero *</label>
              <input v-model="form.bill_zip" class="input pm-input mb-3" placeholder="Postinumero *" />
              <label>Postitoimipaikka *</label>
              <input v-model="form.bill_town" class="input pm-input mb-3" placeholder="Postitoimipaikka *" />
            </div>

            <hr>

            <label>Y-tunnus *</label>
            <input v-model="form.cust_vat_nr" class="input pm-input mb-3" placeholder="Y-tunnus *" />

            <div v-if="errors.length" class="notification is-danger mb-4">
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>

            <button
              class="pyroll-button purple-bg font-white is-fullwidth"
              @click="register"
            >
              Rekisteröidy
            </button>

          </div>
        </div>
      </div>
    </div>

    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import {mapActions, mapMutations} from "vuex"

export default {
  name: 'Register',
  components: {
    PmNavbar,
    PmFooter
  },
  data() {
    return {
      differentBilling: false,
      form: {
        email: '',
        password: '',
        confirmPassword: '',

        // Contact fields
        recv_name: '',
        recv_company: '',
        recv_phone: '',
        recv_street: '',
        recv_zip: '',
        recv_town: '',

        bill_name: '',
        bill_company: '',
        bill_phone: '',
        bill_street: '',
        bill_zip: '',
        bill_town: '',

        cust_email: '',
        cust_vat_nr: ''
      },
      errors: []
    }
  },
  methods: {
    ...mapActions({
      postUser: 'postUser'
    }),
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
      setEmailInUse: 'setEmailInUse'
    }),
    register() {
      this.setEmailInUse('')
      this.errors = []

       // Required fields
      if (!this.form.email) {
        this.errors.push('Sähköpostiosoite pakollinen.')
      }

      if (!this.form.password) {
        this.errors.push('Salasana pakollinen.')
      }

      if (this.form.password.length < 8) {
        this.errors.push('Vähintään 8 merkkiä')
      }

      // Password match
      if (this.form.password && this.form.password !== this.form.confirmPassword) {
        this.errors.push('Salasanat eivät täsmää')
      }

      // Required receiver fields
      if (!this.form.recv_name) this.errors.push('Vastaanottajan nimi pakollinen.')
      if (!this.form.recv_company) this.errors.push('Vastaanottajan yritys pakollinen.')
      if (!this.form.recv_phone) this.errors.push('Vastaanottajan puhelinnumero pakollinen.')
      if (!this.form.recv_street) this.errors.push('Vastaanottajan katuosoite pakollinen.')
      if (!this.form.recv_zip) this.errors.push('Vastaanottajan postinumero pakollinen.')
      if (!this.form.recv_town) this.errors.push('Vastaanottajan kaupunki pakollinen.')

      // Required customer fields
      if (!this.form.cust_vat_nr) this.errors.push('Asiakkaan Y-tunnus pakollinen.')

       // billing required ONLY if checkbox is checked
      if (this.differentBilling) {
        if (!this.form.bill_name) this.errors.push('Laskutuksen nimi pakollinen.')
        if (!this.form.bill_phone) this.errors.push('Laskutuksen puhelinnumero pakollinen.')
        if (!this.form.bill_street) this.errors.push('Laskutuksen katuosoite pakollinen.')
        if (!this.form.bill_zip) this.errors.push('Laskutuksen postinumero pakollinen.')
        if (!this.form.bill_town) this.errors.push('Laskutuksen kaupunki pakollinen.')
      }

      if (this.errors.length) {
        return
      }

      this.setSpinnerState(true)

      this.postUser(
        {
          password: this.form.password,
          email: this.form.email,
          contact: {
            recv_name: this.form.recv_name,
            recv_company: this.form.recv_company,
            recv_phone: this.form.recv_phone,
            recv_street: this.form.recv_street,
            recv_zip: this.form.recv_zip,
            recv_town: this.form.recv_town,

            bill_name: this.differentBilling ? this.form.bill_name : this.form.recv_name,
            bill_company: this.differentBilling ? this.form.bill_company : this.form.recv_company,
            bill_phone: this.differentBilling ? this.form.bill_phone : this.form.recv_phone,
            bill_street: this.differentBilling ? this.form.bill_street : this.form.recv_street,
            bill_zip: this.differentBilling ? this.form.bill_zip : this.form.recv_zip,
            bill_town: this.differentBilling ? this.form.bill_town : this.form.recv_town,

            cust_vat_nr: this.form.cust_vat_nr
          }
        }
      ).then(() => {
        this.setSpinnerState(false)
        if (this.$store.getters.getEmailInUse != '') {
          this.errors.push('Sähköposti on jo käytössä')
          return
        }
        this.$router.push({name: 'Designs'})
      })
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.cart-page {
  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #DEDBD9;
  }
  .border-bottom {
    border-bottom: 1px solid #707070;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #DEDBD9;
  }
}

span.is-clickable {
  color: $pyroll-violet;
  svg {
    width: 20px;
    height: 20px;
  }
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
